








import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Location } from "vue-router";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import InputPassword from "@/components/InputPassword";
import PageTitle from "@/components/PageTitle";

@Component({ name: "PageForgotPasswordSet", components: { InputPassword, BasePage, BaseButton, PageTitle } })
export default class PageForgotPasswordSet extends Vue {
  @Prop({ type: String, default: "" })
  public email!: string;

  @Prop({ type: String, default: "" })
  public token!: string;

  @Prop({ type: Boolean, default: false })
  public readonly changePassword!: boolean;

  public get nextRoute(): Location {
    if (!this.changePassword) {
      return { name: "login" };
    }
    return {
      name: "more",
      query: { section: "account" },
    };
  }

  public loading = false;

  public password = "";

  public async submit() {
    if (!this.password) {
      alert($t("Password field is empty"));
      return;
    }
    try {
      this.loading = true;
      await providers.PasswordResetProvider.change({ data: { password: this.password, token: this.token } });
      this.$router.push(this.nextRoute);
      if (this.changePassword) {
        emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: $t("Password has been changed") });
      }
    } finally {
      this.loading = false;
    }
  }
}
